import { Tab } from '@headlessui/react';
import { useSelector } from 'react-redux';
import { getConcurrents } from '../features/concurrents/concurrentsSlice';
import { classNames } from '../utils';

/**
 * TABS COMPONENT
 * @param {{tabs: string[], panels: Array<JSX.Element>}} props
 * @returns {JSX.Element}
 */
function Tabs({ tabs = [], panels }) {
  const concurrents = useSelector(getConcurrents)

  return (
    <Tab.Group>
      <Tab.List className={`flex items-center justify-center rounded-full bg-gray-200 w-full max-w-2xl mx-auto`}>
        {tabs.map((tab, i) => (
          <div className="tooltip flex-grow w-full" key={i} data-tip={i === tabs.length - 1 ? 'Non disponible pour le moment.' : (concurrents.length <= 0 && tab === "Comparaison concurrents") ? "Veuillez enregistrer au moins un concurrent pour y accéder." : tab}>
            <Tab
              disabled={i === tabs.length - 1 || (concurrents.length <= 0 && tab === "Comparaison concurrents")}
              className={({ selected }) =>
                classNames(
                  `text-gray-500 font-medium py-2 flex-grow lg:py-3 rounded-full disabled:cursor-not-allowed outline-none transition-all`,
                  selected ? 'text-general-teal bg-white shadow-sm w-full' : 'text-gray-500 bg-gray-200'
                )
              }
            >
              {tab}
            </Tab>
          </div>
        ))}
      </Tab.List>
      <Tab.Panels className="mt-2">
        {panels.map((panel, key) => (
          <Tab.Panel key={key}>{panel}</Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group >
  );
}

export default Tabs;
